import { InvoiceTextPlusIcon } from './InvoiceTextPlusIcon';

/**
 * author: Jeff Anders
 * id 828C93B1-47AD-4073-8B25-D56621FB50E7
 * name invoice-text-plus
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-text-plus.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceTextNewIcon = InvoiceTextPlusIcon;
export default InvoiceTextNewIcon